Core.PlacesRouter = Core.SubRouter.extend({
    routes: {
        '': 'places',
        'categories': 'categories'
    },

    places: function() {
        debug.log('places');
        app.setMainView(new PlacesView(), 'directory');
    },

    categories: function() {
        debug.log('place categories');
        app.setMainView(new CategoriesListView({scrolling: true}), 'directory')
    }
})